import keyBy from 'lodash/keyBy';
import map from 'lodash/map';

import { GlobalAction, AttributesState } from '.';

const GET_ATTRIBUTES_START = 'GET_ATTRIBUTES_START';
const GET_ATTRIBUTES_ERROR = 'GET_ATTRIBUTES_ERROR';
const GET_ATTRIBUTES_SUCCESS = 'GET_ATTRIBUTES_SUCCESS';
const ADD_ATTRIBUTES_START = 'ADD_ATTRIBUTES_START';
const ADD_ATTRIBUTES_ERROR = 'ADD_ATTRIBUTES_ERROR';
const ADD_ATTRIBUTES_SUCCESS = 'ADD_ATTRIBUTES_SUCCESS';
const EDIT_ATTRIBUTES_START = 'EDIT_ATTRIBUTES_START';
const EDIT_ATTRIBUTES_ERROR = 'EDIT_ATTRIBUTES_ERROR';
const EDIT_ATTRIBUTES_SUCCESS = 'EDIT_ATTRIBUTES_SUCCESS';
const DELETE_ATTRIBUTES_START = 'DELETE_ATTRIBUTES_START';
const DELETE_ATTRIBUTES_ERROR = 'DELETE_ATTRIBUTES_ERROR';
const DELETE_ATTRIBUTES_SUCCESS = 'DELETE_ATTRIBUTES_SUCCESS';
const UPDATE_ORDER_ATTRIBUTES_START = 'UPDATE_ORDER_ATTRIBUTES_START';
const UPDATE_ORDER_ATTRIBUTES_ERROR = 'UPDATE_ORDER_ATTRIBUTES_ERROR';
const UPDATE_ORDER_ATTRIBUTES_SUCCESS = 'UPDATE_ORDER_ATTRIBUTES_SUCCESS';
const GET_VIDEO_ATTRIBUTES_START = 'GET_VIDEO_ATTRIBUTES_START';
const GET_VIDEO_ATTRIBUTES_SUCCESS = 'GET_VIDEO_ATTRIBUTES_SUCCESS';
const UPDATE_VIDEO_ATTRIBUTES_START = 'UPDATE_VIDEO_ATTRIBUTES_START';
const UPDATE_VIDEO_ATTRIBUTES_SUCCESS = 'UPDATE_VIDEO_ATTRIBUTES_SUCCESS';

export const attributesReducer = (
  state: AttributesState,
  action: GlobalAction
): AttributesState => {
  const { payload, type } = action;
  switch (type) {
    case GET_ATTRIBUTES_START: {
      return {
        ...state,
        loading: true,
      };
    }
    case GET_ATTRIBUTES_ERROR: {
      return {
        ...state,
        loading: false,
      };
    }
    case GET_ATTRIBUTES_SUCCESS:
    case UPDATE_ORDER_ATTRIBUTES_SUCCESS: {
      return {
        ...state,
        attributes: keyBy(payload.attributes, 'attributeId'),
        order: map(payload.attributes, 'attributeId'),
        loading: false,
      };
    }
    case ADD_ATTRIBUTES_SUCCESS: {
      return {
        ...state,
        attributes: {
          ...state.attributes,
          [payload.attribute.attributeId]: payload.attribute,
        },
        order: [...state.order, payload.attribute.attributeId],
      };
    }
    case EDIT_ATTRIBUTES_SUCCESS: {
      return {
        ...state,
        attributes: {
          ...state.attributes,
          [payload.attribute.attributeId]: payload.attribute,
        },
      };
    }
    case DELETE_ATTRIBUTES_SUCCESS: {
      const attributeId = payload.attribute.attributeId;
      const copyState = { ...state };
      delete copyState.attributes[attributeId];
      copyState.order = copyState.order.filter(
        (id: string) => id !== attributeId
      );

      return copyState;
    }
    case GET_VIDEO_ATTRIBUTES_SUCCESS:
    case UPDATE_VIDEO_ATTRIBUTES_SUCCESS: {
      return {
        ...state,
        videoAttributes: keyBy(payload.videoAttributes, 'attributeId'),
        loading: false,
      };
    }
    default:
      return state;
  }
};

export const ATTRIBUTES_ACTIONS = {
  GET_ATTRIBUTES_START,
  GET_ATTRIBUTES_ERROR,
  GET_ATTRIBUTES_SUCCESS,
  ADD_ATTRIBUTES_START,
  ADD_ATTRIBUTES_ERROR,
  ADD_ATTRIBUTES_SUCCESS,
  EDIT_ATTRIBUTES_START,
  EDIT_ATTRIBUTES_ERROR,
  EDIT_ATTRIBUTES_SUCCESS,
  DELETE_ATTRIBUTES_START,
  DELETE_ATTRIBUTES_ERROR,
  DELETE_ATTRIBUTES_SUCCESS,
  UPDATE_ORDER_ATTRIBUTES_START,
  UPDATE_ORDER_ATTRIBUTES_ERROR,
  UPDATE_ORDER_ATTRIBUTES_SUCCESS,
  GET_VIDEO_ATTRIBUTES_START,
  GET_VIDEO_ATTRIBUTES_SUCCESS,
  UPDATE_VIDEO_ATTRIBUTES_START,
  UPDATE_VIDEO_ATTRIBUTES_SUCCESS,
};
